module.exports = __webpack_public_path__ + "static/media/Simbolo_SevenG.b7b08966.png";